import { render, staticRenderFns } from "./taskTransfer.vue?vue&type=template&id=fcce9bc4&"
import script from "./taskTransfer.vue?vue&type=script&lang=ts&"
export * from "./taskTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports